<template>
  <section class="page-shell article-page">
    <article v-if="guide">
      <button class="legal-back" @click="navigate('guides')">← All guides</button>
      <span class="eyebrow"><span></span>{{ guide.category }}</span>
      <h1>{{ guide.title }}</h1>
      <p class="article-meta">Updated {{ guide.updated }} · {{ guide.readTime }} · CalmDecide Editorial</p>
      <p class="article-intro">{{ guide.intro }}</p>

      <section v-for="section in guide.sections" :key="section.heading">
        <h2>{{ section.heading }}</h2>
        <p v-for="paragraph in section.body" :key="paragraph">{{ paragraph }}</p>
      </section>

      <div class="article-note">
        <strong>Use the tool after reading</strong>
        <p>If this guide clarified what kind of decision you are facing, use Quick Choice for low-stakes options or Think It Through for weighted tradeoffs.</p>
        <div>
          <button class="soft-button" @click="navigate('quick')">Quick choice</button>
          <button class="primary-button" @click="navigate('deep')">Think it through</button>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import guides from '../content/guides'

export default {
  name: 'GuideArticleView',
  inject: ['navigate'],
  props: {
    slug: { type: String, default: '' }
  },
  computed: {
    guide () { return guides.find(guide => guide.slug === this.slug) || guides[0] }
  }
}
</script>
